import {DomainSettingsQuery} from "@/components/domain_settings/settings/queries.generated";
import {PrivateRoutingType} from "@/api";
import {ImageType} from "@/components/domain_settings/settings/DomainSettingsPage";
import {DomainSettingsValues} from "./DomainSettingsForm";

export function createInitialData(settings?: DomainSettingsQuery): DomainSettingsValues {
    if (!settings)
        return {
            id: 0,
            description: "",
            companyName: "",
            preferDisplayNamesForStationNames: false,
            shortNumbersLength: 4,
            specialNumbersDialoutPrefix: "",
            smtp: {
                enabled: false,
                username: "",
                userpass: "",
            },
            pinBasedCalls: false,
            privateRoutingType: PrivateRoutingType.GatewayWithPstnFallback,
            dialoutPrefix: "",
            attendantPrefix: "",
            requirePinForStartingPrivateCalls: false,
            groupDomain: "",
            faxSignature: "",
            baseColor: "",
            login: {
                backgroundColor: "",
                logoImage: undefined,
            },
            background: {
                image: undefined,
                isCentered: false,
                color: "",
            },
            logo: undefined,
            sounds: {
                moh: undefined,
                park: undefined,
            },
            outgoingCallBarring: {
                operator: [],
                admin: [],
            },
            recording: {
                retention: 0,
                location: undefined,
            },
            presenceInDomainPreauthorized: false,
            imageUrls: {},
        };

    const domain = settings.domains.items[0];
    const loginImage = domain.images.find((img) => img.type == ImageType.LOGIN);
    const backgroundImage = domain.images.find((img) => img.type == ImageType.BACKGROUND);
    const logoImage = domain.images.find((img) => img.type == ImageType.LOGO);

    return {
        id: domain.id,
        description: domain.description,
        companyName: domain.companyName,
        preferDisplayNamesForStationNames: domain.preferDisplayNamesForStationNames,
        shortNumbersLength: domain.shortNumbersLength,
        specialNumbersDialoutPrefix: domain.specialNumbersDialoutPrefix,
        smtp: {
            enabled: domain.smtpAuthEnabled,
            username: domain.smtpUsername,
            userpass: domain.smtpUserpass,
        },
        pinBasedCalls: domain.pinBasedCalls,
        privateRoutingType: domain.privateRoutingType,
        dialoutPrefix: domain.dialoutPrefix,
        attendantPrefix: domain.attendantPrefix,
        requirePinForStartingPrivateCalls: domain.requirePinForStartingPrivateCalls,
        groupDomain: domain.groupDomain,
        faxSignature: domain.faxSignature,
        baseColor: domain.baseColor,
        login: {
            backgroundColor: domain.loginBackgroundColor,
            logoImage: loginImage
                ? {
                      id: loginImage.id,
                      description: loginImage.hash,
                      file: null,
                  }
                : null,
        },
        background: {
            image: backgroundImage
                ? {
                      id: backgroundImage.id,
                      description: backgroundImage.hash,
                      file: null,
                  }
                : null,
            isCentered: domain.backgroundIsCenter,
            color: domain.backgroundColor,
        },
        logo: logoImage
            ? {
                  id: logoImage.id,
                  description: logoImage.hash,
                  file: null,
              }
            : null,
        sounds: {
            moh: domain.mohSound
                ? {
                      id: domain.mohSound.id,
                      description: domain.mohSound.description,
                      file: undefined,
                      unset: false,
                  }
                : {
                      id: undefined,
                      description: undefined,
                      file: undefined,
                      unset: true,
                  },
            park: domain.parkSound
                ? {
                      id: domain.parkSound.id,
                      description: domain.parkSound.description,
                      file: undefined,
                      unset: false,
                  }
                : {
                      id: undefined,
                      description: undefined,
                      file: undefined,
                      unset: true,
                  },
        },
        outgoingCallBarring: {
            operator: domain.outgoingCallBarringOperator,
            admin: domain.outgoingCallBarringAdmin,
        },
        recording: {
            retention: domain.recordingRetention ?? 0,
            location: domain.recordingLocation,
        },
        presenceInDomainPreauthorized: domain.presenceInDomainPreauthorized,
        imageUrls: {
            background: settings.domainTheme.background,
            logo: settings.domainTheme.logo,
            loginLogo: settings.domainTheme.login,
        },
    };
}
